import React, { useState } from 'react';
import { 
  TextField, 
  Button, 
  Box, 
  Typography, 
  CircularProgress, 
  Alert, 
  List, 
  ListItem, 
  ListItemText,
  Tabs,
  Tab,
  Paper
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const SearchForm = ({ onSearch, onNameSearch, loading, error }) => {
  const [searchType, setSearchType] = useState(0); // 0 = DNI, 1 = Name
  const [dni, setDni] = useState('');
  const [nombre, setNombre] = useState('');
  const [apellido, setApellido] = useState('');

  const handleTabChange = (event, newValue) => {
    setSearchType(newValue);
    // Clear form fields when switching tabs
    setDni('');
    setNombre('');
    setApellido('');
  };

  const handleDniSubmit = (e) => {
    e.preventDefault();
    if (dni.trim()) {
      onSearch(dni);
    }
  };

  const handleNameSubmit = (e) => {
    e.preventDefault();
    if (nombre.trim() || apellido.trim()) {
      onNameSearch({ nombre: nombre.trim(), apellido: apellido.trim() });
    }
  };

  return (
    <Box sx={{ mb: 4, textAlign: 'center' }}>
      <Typography variant="h5" gutterBottom>
        Consulta de Afiliado
      </Typography>
      
      <Paper elevation={2} sx={{ maxWidth: 600, mx: 'auto', p: 3 }}>
        <Tabs 
          value={searchType} 
          onChange={handleTabChange} 
          centered
          sx={{ mb: 3 }}
        >
          <Tab label="Buscar por DNI" />
          <Tab label="Buscar por Nombre" />
        </Tabs>

        {searchType === 0 && (
          <Box component="form" onSubmit={handleDniSubmit}>
            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', alignItems: 'center', mb: 2 }}>
              <TextField
                label="Ingrese DNI"
                variant="outlined"
                value={dni}
                onChange={(e) => setDni(e.target.value)}
                disabled={loading}
                size="small"
                sx={{ width: 250 }}
                inputProps={{ maxLength: 8, inputMode: 'numeric', pattern: '[0-9]*' }}
              />
              
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={!dni.trim() || loading}
                startIcon={loading ? <CircularProgress size={20} /> : <SearchIcon />}
              >
                {loading ? 'Buscando...' : 'Buscar'}
              </Button>
            </Box>
          </Box>
        )}

        {searchType === 1 && (
          <Box component="form" onSubmit={handleNameSubmit}>
            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', alignItems: 'flex-start', mb: 2, flexWrap: 'wrap' }}>
              <TextField
                label="Nombre"
                variant="outlined"
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
                disabled={loading}
                size="small"
                sx={{ width: 200 }}
                inputProps={{ maxLength: 50 }}
              />
              
              <TextField
                label="Apellido"
                variant="outlined"
                value={apellido}
                onChange={(e) => setApellido(e.target.value)}
                disabled={loading}
                size="small"
                sx={{ width: 200 }}
                inputProps={{ maxLength: 50 }}
              />
              
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={(!nombre.trim() && !apellido.trim()) || loading}
                startIcon={loading ? <CircularProgress size={20} /> : <SearchIcon />}
              >
                {loading ? 'Buscando...' : 'Buscar'}
              </Button>
            </Box>
            
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Puede buscar por nombre, apellido o ambos
            </Typography>
          </Box>
        )}
      </Paper>
      
      {error && (
        <Alert severity="error" sx={{ mt: 2, maxWidth: 600, mx: 'auto' }}>
          {typeof error === 'string' ? (
            <Typography variant="subtitle1">{error}</Typography>
          ) : (
            <>
              <Typography variant="subtitle1">{error.message || 'Error en la consulta'}</Typography>
              {error.details && <Typography variant="body2">{error.details}</Typography>}
              {error.similar_dnis && error.similar_dnis.length > 0 && (
                <Box sx={{ mt: 1 }}>
                  <Typography variant="body2" fontWeight="bold">DNIs similares encontrados:</Typography>
                  <List dense>
                    {error.similar_dnis.map((item, index) => (
                      <ListItem key={index}>
                        <ListItemText 
                          primary={`${item.dni} - ${item.nombre}`}
                          sx={{ '& .MuiListItemText-primary': { fontFamily: 'monospace' } }}
                        />
                      </ListItem>
                    ))}
                  </List>
                </Box>
              )}
            </>
          )}
        </Alert>
      )}
    </Box>
  );
};

export default SearchForm;
